module.exports = __webpack_public_path__ + "static/apple-icon-180x180-e9a8d4ef09e524a4ad3a49dad056bfd1.png";